export default "__VITE_ASSET__ce989854__"